import styled from '@emotion/styled';
import {Button} from '@bosch/react-frok';

export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
`;

export const DialogEditActionsWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
`;

export const TabNavigationWrapper = styled.div`
    .a-tab-navigation {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: start;
        border-color: transparent;
        border-bottom: 1px solid var(--bosch-gray-40);
    }

    .a-tab-navigation__wrapper {
        position:relative;
        margin-top:1em;
        margin-bottom:1em;
    }

    .a-tab-navigation__gradients {
        position: inherit;
    }
`;

export const TabNavigation = styled.ol`
    list-style: none;
    margin: 0 0 0.5rem 0;
    padding: 0;
`;

export const TabButton = styled(Button)`
    padding: 0 1rem 0 0;
    min-width: 64px;
`;

export const SpreadButton = styled(Button)`
    margin-left: 0rem;
    margin-right: 1rem;
    margin-top:1.5rem ;
    min-width: 120px;
`;

export const DeleteButton = styled(Button)`
    margin-left: 0rem;
    margin-right: 1rem;
    margin-top:1.5rem ;
    min-width: 120px;
`;

export const AddButton = styled(Button)`
    margin-left: 0rem;
    margin-right: 1rem;
    margin-top:1.5rem ;
    min-width: 120px;
`;

export const ResetButton = styled(Button)`
    margin-left: 0rem;
    margin-right: 1rem;
    margin-top:1.5rem ;
    min-width: 120px;
`;